angular.module( 'acme.view.application.layouts.tickets.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.layouts.tickets.list.controllers',
  'acme.view.application.layouts.tickets.removeModal.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var layoutsTicketsList = {
        name: 'application.layouts.tickets.list',
        url: '/list',
        views: {
          "subview-main": {
            controller: 'LayoutsTicketsListController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/layouts/tickets/list/list.tpl.html'
          }
        },
        data: {
          pageTitle: 'Ticket Layouts',
          /** Secure With Permissions **/
          permissions: ['TICKET_LAYOUTS_VIEW']
        }
      };

    $stateProvider
      .state(layoutsTicketsList);
});
